import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog, DialogContent } from "../../../components";
import {
  MarcasService,
  notification,
  ProdutosService,
} from "../../../services";
import { responseErros } from "../../../utils";
import AddMarcas from "../addMarcas/addMarcas.view";
import { PermisoesHelper } from "../../../helpers";

const ListMarcas = () => {
  const [id, setId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [marcas, setMarcas] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [produtosList, setProdutosList] = useState([]);
  const colunas = [
    {
      field: "nome",
      headerName: "Nome",
      flex: 1000,
      filtrar: true,
    },
    {
      field: "ativado",
      headerName: "Status",
      flex: 500,
      valueGetter: (params) => (params.value ? "Ativado" : "Desativado"),
    },
  ];
  const marcasService = new MarcasService();
  const produtosService = new ProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("marcas-visualizar");

  useEffect(() => {
    buscarMarcas();
  }, [openDialog]);

  useEffect(() => {
    buscarProdutos();
  }, []);

  const buscarMarcas = async function (filter) {
    setLoading(true);
    const result = await marcasService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setMarcas(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarProdutos = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await produtosService.getAllProdutosSimples(filtros);
    if (!res.isAxiosError) {
      setProdutosList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleClickOpenDialog = (id) => {
    setId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onClickDeleteMarca = async function (id) {
    const produto = produtosList.some((item) => item.marcaId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir essa marca?`
    );
    if (retornoAlerta.isConfirmed) {
      if (produto) {
        notification.alertaGenericos(
          "Não se pode remover Marcas inserida em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await marcasService.deletar(id);
      if (!result.isAxiosError) {
        buscarMarcas();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const sendServerDatagrid = (props) => {
    buscarMarcas(props.filtros);
  };

  return (
    <ListLayout
      title="Marcas"
      loading={loading}
      onClickCadastrar={handleClickOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("marcas-cadastrar")}
    >
      <DataGrid
        rows={marcas}
        columns={colunas}
        onClickEdit={handleClickOpenDialog}
        onClickDelete={onClickDeleteMarca}
        editShow={permissoesHelper.temPermisao("marcas-editar")}
        deleteShow={permissoesHelper.temPermisao("marcas-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        PaperComponent="div"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <AddMarcas id={id} handleCloseDialog={handleCloseDialog} />
        </DialogContent>
      </Dialog>
    </ListLayout>
  );
};

export default ListMarcas;
